var needToPoll = false;

var resizeDecks = function() {
  $('.mtggoldfish_widget').each(function() {
    $(this).height($(this).contents().find("body").height() + 5);
  });
};

var pollResizeDecks = function() {
  // check any ajax spinners in iframe
  needToPoll = ($('.mtggoldfish_widget').contents().find("body").find(".ajax-spinner").length);
  resizeDecks();
  if (needToPoll) {
    setTimeout(pollResizeDecks, 500);
  }
};

$(function() {
  /*
  $(".article-tile").dotdotdot({ after: ".article-tile-link-overlay" });
  $( window ).resize(function() {
    $(".article-tile").dotdotdot({ after: ".article-tile-link-overlay" });
  });
  */
  $( window ).resize(resizeDecks);
  $(".mtggoldfish_widget").on("load", pollResizeDecks);

  $("<p class='text-center'><a class='spoilertag-trigger' href='javascript:;'>Spoiler. Hover or click here to reveal.</a></p>").insertBefore(".spoilertag");
  $(".spoilertag").append("<div class='spoilertag-blocker'></div>");
  $(".spoilertag-trigger").hover(function(e) {
    $(e.target).parent().next().find(".spoilertag-blocker").css("opacity", 0).css("z-index", -1);
  }).click(function(e) {
    $(e.target).parent().next().find(".spoilertag-blocker").css("opacity", 0).css("z-index", -1);
  });
  $(".spoilertag").css("visibility", "visible");

  $(".article-form-add-btn").click( function(e) {
    var tag = $.trim($(".article-form-add-input").val());
    if (tag != "") {
      var spanTag = $("<span class='article-tag label edit'>" + tag + " x</span>");
      var inputTag = $("<input/>", { name: "article[tag_list][]", type: "hidden", value: tag });
      spanTag.append(inputTag);
      $(".article-form-taglist").append(spanTag);
    }
    
  });
  $(document).on('click', '.article-tag.edit', function (e) {
    $(this).remove();
  }); 

  $(document).on('click', '.articles-series-show-more-btn', function (e) {
    $(".articles-series-show-more").slice(0, 10).each(function(index) {
      $(this).toggle(true);
      $(this).removeClass("articles-series-show-more");
    });

    if (!$(".articles-series-show-more").length) {
      $(".articles-series-show-more-btn").toggle(false);
    }
  });
});


window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() { 
  $('.article-slideshow').each(function(i){
    var id = $(this).attr('id');
    $(this).find('.article-slideshow-image').colorbox({rel: id});
  });
});
